import type { ReactNode } from "react";
import { Text, View } from "react-native";

export function EmptyState({
  icon,
  title,
  subtitle,
  action,
}: {
  icon?: ReactNode;
  title: string;
  subtitle?: string;
  action?: ReactNode;
}) {
  return (
    <View className="items-center px-6 py-10">
      <Text className="mb-3 text-[29px] opacity-30">{icon ?? "○"}</Text>
      <Text className="text-center text-[19px] text-text/70">{title}</Text>
      {subtitle ? <Text className="mt-2 text-center text-[12px] leading-5 text-text/55">{subtitle}</Text> : null}
      {action ? <View className="mt-4">{action}</View> : null}
    </View>
  );
}
